import { createModalHook } from '../../hooks/useModal'

export const useChangePaymentDateModal = createModalHook()
